import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/ui/shadcn/dialog';
import { Button } from '@/shared/ui/shadcn/button';

import { documentRecipientFromMarkdown, type DocumentDraft } from '@/entities/document-draft';

interface FaxEditorSendDialogProps {
  draft: DocumentDraft;
  open: boolean;
  sending: boolean;
  onOpenChange(open: boolean): void;
  onSend(): void;
}

export function FaxEditorSendDialog({
  draft,
  open,
  sending,
  onOpenChange,
  onSend,
}: FaxEditorSendDialogProps) {
  const recipient = documentRecipientFromMarkdown(draft.content.bodyMarkdown);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Send fax?</DialogTitle>
          <DialogDescription>
            This will send the reviewed fax for this patient to the following destination.
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-md border bg-muted/20 p-3 text-sm">
          <p className="font-medium">{recipient.name}</p>
          <p className="text-muted-foreground">{recipient.organization}</p>
          <p className="font-mono text-xs">{recipient.faxNumber}</p>
        </div>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={sending}
          >
            Cancel
          </Button>
          <Button type="button" onClick={onSend} disabled={sending}>
            {sending ? 'Sending…' : 'Confirm send'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
